import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import UserNewsModal from './UserNewsModal';
import Modal from 'components/GeneralComponents/Modal';
import { appOperations } from 'App/duck';
import { getLocationCode } from 'helpers/cookies';
import styledConfirm from 'pages/Requests/components/styled';
import { markNewsAsRead, hideUserNewsModal } from 'App/duck/slices/userNews';

const mapStateToProps = (state) => {
  return {
    showModal: state.userNews?.showModal || false,
    currentNews: state.userNews?.currentNews || null,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { history } = ownProps;
  const markUserNewsAsRead = (newsId) => {
    dispatch(markNewsAsRead(newsId));
  };

  const hideUserNewsModalAction = () => {
    dispatch(hideUserNewsModal());
  };

  const handleUserNewsAction = (news) => {
    const { action, location_id, category, link } = news;
    if (category === 'TRIAL_PROMOTE') {
      history.push('/settings/subscription');
      return;
    }
    switch (action) {
      case 'contact_invite':
        history.push('/usermanagement');
        break;
      case 'navigate':
      case 'open_link':
        if (link) {
          window.open(link, '_blank');
        }
        break;
      default:
        break;
    }
  };

  return {
    onMarkAsRead: markUserNewsAsRead,
    onClose: hideUserNewsModalAction,
    onAction: handleUserNewsAction,
  };
};

const ConnectedUserNewsModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserNewsModal);

const UserNewsContainer = (props) => {
  const history = useHistory();
  const { showModal, ...rest } = props;
  if (!showModal) {
    return null;
  }
  return (
    <>
      <Modal>
        <ConnectedUserNewsModal {...rest} history={history} />
      </Modal>
      <styledConfirm.Overlay display={showModal ? 'block' : 'none'} />
    </>
  );
};

export default connect(
  mapStateToProps,
  null
)(UserNewsContainer); 